import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCoin1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="coin-1, credits, money"><path d="M12.75 2.75H10.5C6.21979 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.21979 21.25 10.5 21.25H12.75M21.25 12C21.25 17.1086 17.7802 21.25 13.5 21.25C9.21979 21.25 5.75 17.1086 5.75 12C5.75 6.89137 9.21979 2.75 13.5 2.75C17.7802 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCoin1;
